// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './components/login/login.component';
import { AuthRoutingModule } from './auth-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { DescriptionComponent } from './components/description/description.component';
import { TextAnimationModule } from '@coa/app/shared/text-animation/text-animation.module';
import { PreviousUrlService } from '@coa/app/libs/services/previous-url.service';
import { LibAuthModule } from '@coa/app/libs/auth/auth-module/lib-auth.module';

@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    MatIconModule,
    TextAnimationModule,
    LibAuthModule,
  ],
  declarations: [
    AuthComponent,
    LoginComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    DescriptionComponent,
  ],
  providers: [
    PreviousUrlService,
  ],
})
export class AuthModule {
}
